import { Modal, Grid, Text } from '@simplywallst/ui-core';

export const InformationModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Modal
      title="Legacy Portfolios"
      onSecondaryClick={onClose}
      secondaryLabel="Close"
      data-cy-id="legacy-portfolios-info-modal"
    >
      <Grid gap="16px">
        <Text color="inherit" typography="xSmall">
          You can continue using the old version of portfolio for as long as
          you'd like, while we continue to develop the new one. We'll keep you
          updated on improvements, and you'll be able to migrate to the new
          portfolio anytime with just a single click, without losing any
          information.
        </Text>
      </Grid>
    </Modal>
  );
};
